var d2Analysis = require('./lib');

module.exports = d2Analysis;



/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/index.js
 ** module id = 24
 ** module chunks = 0 1
 **/